export default {"src":"/_next/static/media/lumen.0ff2fde3.svg","height":1497,"width":1503};